import * as React from "react";

function SvgCheckboxButton(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={17} height={17} {...props}>
      <path
        d="M8.5 0a8.5 8.5 0 00-6.01 14.511A8.5 8.5 0 0014.511 2.489 8.445 8.445 0 008.5 0zm0 15.8A7.306 7.306 0 015.656 1.77a7.3 7.3 0 018.009 11.895A7.285 7.285 0 018.5 15.8zm3.9-10.9a.592.592 0 00-.422.176l-5.441 5.451L5.12 8.045a.6.6 0 00-1.095.139.593.593 0 00.057.453L5.889 11.8a.6.6 0 00.52.3.586.586 0 00.3-.078.614.614 0 00.141-.111l.006-.007 5.963-5.984a.6.6 0 000-.845.589.589 0 00-.419-.175z"
        fill="current"
      />
    </svg>
  );
}

export default SvgCheckboxButton;
